// extracted by mini-css-extract-plugin
export default {"words":"Words_words__n-4ub","tiles":"Words_tiles__On6oL","correct":"Words_correct__J64AB","incorrect":"Words_incorrect__2LIyy","partiallyCorrect":"Words_partiallyCorrect__aG7Uf"};